export const STATE_MAPPINGS = {
  flowsactive: 'app.runner.flowsactive',
  flowstodo: 'app.runner.flowstodo',
  flowsin: 'app.runner.flowsin',
  reports: 'app.runner.reports',
  processmapsv2: 'app.runner.processmapv2',
  processmapviewv2: 'app.runner.processmapviewv2',
  library: 'app.runner.library',
  libraryworkflows: 'app.runner.library.workflows',
  libraryprocessmaps: 'app.runner.library.processmaps',
  libraryprocedures: 'app.runner.library.procedures',
  librarydrafts: 'app.runner.library.drafts',
  exagoSingle: 'app.runner.exagosingle',
  exago: 'app.runner.exago',
  flow: 'app.runner.flow',
  search: 'app.runner.search',
  report: 'app.runner.report',
  procedure: 'app.runner.procedure',
  publicForm: 'app.public-form',
  publicMap: 'app.publicmap',
  publicSop: 'app.publicsop',
  procedures: 'app.runner.procedures',
  profile: 'app.runner.profile',
  signup: 'app.signup',
  libraryFormThemes: 'app.runner.library.formthemes',
  libraryFormTheme: 'app.runner.library.formtheme',
  templatesLibrary: 'app.runner.templates.library',
  maintenanceSettings: 'app.runner.maintenance.settings',
  maintenanceEmails: 'app.runner.maintenance.emails',
  maintenanceApplicationSettings: 'app.runner.maintenance.applicationsettings',
  maintenanceFlows: 'app.runner.maintenance.flows',
  maintenanceFlowModels: 'app.runner.maintenance.flowmodels',
  maintenanceValidation: 'app.runner.maintenance.validation',
  maintenanceUsers: 'app.runner.maintenance.users',
  maintenanceBusiness: 'app.runner.maintenance.business',
  maintenanceReports: 'app.runner.maintenance.reports',
  login: 'app.login',
  accept: 'app.accept',
  print: 'app.print.',
  printFlow: 'app.print.flow',
  printFlowmodelschema: 'app.print.flowmodelschema',
  sso: 'app.sso',
  governance: 'app.runner.governance',
  settings: 'app.runner.settings',
  notifications: 'app.runner.notifications',
  setupusers: 'app.runner.setup.users',
  setupcategories: 'app.runner.setup.categories',
  setupdatabases: 'app.runner.setup.databases',
  createDatabase: 'app.runner.create-database',
  editDatabase: 'app.runner.edit-database',
  setupteams: 'app.runner.setup.teams',
  setuptaggroups: 'app.runner.setup.taggroups',
  setuproles: 'app.runner.setup.roles',
  creationHub: 'app.runner.creation-hub.index',
  creationHubProcessMap: 'app.runner.creation-hub.process-map.index',
  creationHubProcessMapFromScratch:
    'app.runner.creation-hub.process-map.from-scratch',
  creationHubProcessMapFromText:
    'app.runner.creation-hub.process-map.from-text',
  creationHubProcessMapFromImage:
    'app.runner.creation-hub.process-map.from-image',
  creationHubProcessMapFromCsv: 'app.runner.creation-hub.process-map.from-csv',
  creationHubProcessMapFromVideo:
    'app.runner.creation-hub.process-map.from-video',
  creationHubProcessMapFromAudio:
    'app.runner.creation-hub.process-map.from-audio',
  creationHubProcessMapFromRecording:
    'app.runner.creation-hub.process-map.from-recording',
  creationHubWorkflow: 'app.runner.creation-hub.workflow.index',
  creationHubWorkflowFromScratch:
    'app.runner.creation-hub.workflow.from-scratch',
  creationHubWorkflowFromText: 'app.runner.creation-hub.workflow.from-text',
  creationHubWorkflowFromImage: 'app.runner.creation-hub.workflow.from-image',
  creationHubWorkflowFromCsv: 'app.runner.creation-hub.workflow.from-csv',
  creationHubWorkflowFromVideo: 'app.runner.creation-hub.workflow.from-video',
  creationHubWorkflowFromAudio: 'app.runner.creation-hub.workflow.from-audio',
  creationHubWorkflowFromRecording:
    'app.runner.creation-hub.workflow.from-recording',
  creationHubProcedure: 'app.runner.creation-hub.procedure.index',
  creationHubProcedureFromScratch:
    'app.runner.creation-hub.procedure.from-scratch',
  creationHubProcedureFromExtension:
    'app.runner.creation-hub.procedure.from-extension',
  creationHubProcedureFromExtensionWithAi:
    'app.runner.creation-hub.procedure.from-extension-with-ai',
  creationHubProcedureFromRecording:
    'app.runner.creation-hub.procedure.from-recording',
  creationHubProcedureFromVideo: 'app.runner.creation-hub.procedure.from-video'
};
